import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/page.tsx");
